export const CREATE_ROUTE = process.env.REACT_APP_CREATE_ROUTE;
export const CDN_140 = 'https://cdn140.picsart.com';
// unsplash max image size
export const UNSPLASH_MAX_SIZE = 300;

export enum DEEPLINKS {
  gDriveState = 'state',
  type = 'type',
  eraserOpen = 'eraserOpen',
  eraserType = 'eraserType',
  patchOpen = 'patchOpened',
  cropOpen = 'cropOpen',
  templateCategory = 'templateCategory',
  templateSearch = 'templateSearch',
  templatesTitle = 'templatesTitle',
  templatesSubTitle = 'templatesSubTitle',
  search = 'search',
  category = 'category',
  template = 'template',
  layout = 'layout',
  photos = 'photos',
  stickers = 'stickers',
  image = 'image',
  imageId = 'imageId',
  stickerId = 'stickerId',
  projectId = 'projectId',
  templateSize = 'templateSize',
  customSize = 'customSize',
  unit = 'unit',
  tab = 'tab',
  batch = 'batch',
  batch_key = 'batch_key',
  collectionId = 'collectionId',
  logo = 'logo',
  title = 'title',
  apiKey = 'apiKey',
  embedded = 'embedded',
  hideCancelBtn = 'hideCancelBtn',
  nextButtonLabel = 'nextButtonLabel',
  categories = 'categories',
  tools = 'tools',
  dimensions = 'dimensions',
  templatesSubType = 'templatesSubType',
  // monetization
  paymentFlow = 'paymentFlow',
  resultCode = 'resultCode',
  refusalReason = 'refusalReason',
  text = 'text',
  sdkInstanceId = 'instanceId',
  // analytics,
  origin = 'origin',
  source = 'source',
  sourceId = 'source_id',
  removeBG = 'removeBG',
}

export enum PROD_TOOL_URLS {
  templateEditor = 'editor',
  upscale = 'upscale',
  removeBackground = 'remove-background',
}

export const MAIN_CANVAS_SIZES = {
  minCM: 0.43,
  minPixel: 16,
  minInch: 0.17,
  maxCM: 211.66,
  maxInch: 83.33,
  maxPixel: 8000,
};

export interface ICreateDialogTypes {
  closeHandler?: () => void;
  onSuccessHandler: (value?: { [key: string]: any }) => Promise<void> | void;
  headerText?: string;
  mainText?: string;
}

export interface ICreateDialog {
  children?: React.ReactNode;
  inputName?: string;
  iconName?: boolean;
  onChange?: () => void;
  onClick: (width: number, height: number, unit: string) => void;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export enum MEASUREMENTS_MAP {
  pixel = 'px',
  inch = 'in',
  centimeter = 'cm',
}

export const measurementUnitData = [
  {
    label: MEASUREMENTS_MAP.pixel,
    value: MEASUREMENTS_MAP.pixel,
  },
  {
    label: MEASUREMENTS_MAP.inch,
    value: MEASUREMENTS_MAP.inch,
  },
  {
    label: MEASUREMENTS_MAP.centimeter,
    value: MEASUREMENTS_MAP.centimeter,
  },
];

export const REGISTRATION_POINT = {
  COOKIE_NAME: 'we-registrationPoint',
  HOME: 'home',
  REGISTRATION_DONE: 'we-registration-',
};
export const HEADER_MONETIZATION_BUTTON = 'header-monetization-button';
export const HEADER_MONETIZATION_BUTTON_TEXT = 'header-monetization-button-text';

export const FREE_TRIAL_TRIGGER = 'we-loginPoint';

export const DEFAULT_LANGUAGE_CODE = 'en';

export const LANGUAGE_COOKIE = 'language';

export const INTERNAL_ANALYTICS_PREFIX = 'paa';
export const PREV_TAB_ID = `${INTERNAL_ANALYTICS_PREFIX}_tab_id`;
